import type { Locales } from 'config';

import type { Utilities } from './utilities';

type Breadcrumb = {
  name: string;
  url: string;
};

type Breakpoints = {
  xs: number;
  mxs: number;
  ix: number;
  sm: number;
  is: number;
  md: number;
  im: number;
  lg: number;
  xl: number;
  xxl: number;
  xxxl: number;
};

type I18n = {
  country: string;
  locale: Locales;
  currency: string;
};

type Location = {
  current: string;
  previous: string;
};

export type Loader = {
  isLoading: boolean;
  message: string;
};

export type Notification = {
  icon?: string;
  id?: string;
  message: React.ReactNode;
  position?: NOTIFICATION_POSITION;
  status?: NOTIFICATION_STATUS;
  timeout?: number;
  type?: string;
  showIcon?: boolean;
};

export enum NOTIFICATION_STATUS {
  INFO = 'info',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum NOTIFICATION_POSITION {
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  TOP_CENTER = 'top-center',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
}

export type App = {
  breadcrumbs: Breadcrumb[];
  canLoadVWO: boolean;
  hasTouch: boolean;
  i18n: I18n;
  isCartActive: boolean;
  isDrawerActive: boolean;
  isMobile: boolean;
  isMobileMenuActive: boolean;
  isModalActive: boolean;
  isOverlayVisible: boolean;
  isPointsProgramActive: boolean;
  isProductNotFoundShippingActive: boolean;
  isScrollLocked: boolean;
  isSearchActive: boolean;
  isShippingActive: boolean;
  loader: Loader;
  location: Location;
  notifications: Notification[];
  screenSize: keyof Breakpoints;
  status: Utilities.STATUS;
  version: string;
};
